var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0342 2.11765C4.58293 2.11765 0.144714 7.90588 0.144714 15.0588C0.144714 22.2118 4.58293 28 10.0342 28C15.5096 28 19.9237 22.2118 19.9237 15.0588C19.9237 7.90588 15.5096 2.11765 10.0342 2.11765ZM8.85231 25.8824C8.85231 25.8824 10.8302 20.2588 9.11764 13.8588C8.27341 10.6824 8.99703 8.23529 9.62417 6.54118C10.179 5.05882 11.1197 4.65882 11.3367 4.58824C11.2644 4.75294 9.86538 8.58824 11.1438 13.3412C13.1699 20.8941 8.99703 25.7176 8.85231 25.8824ZM29.572 17.0353C27.6183 15.1294 23.976 15.6471 21.4192 18.2118C18.8624 20.7765 18.38 24.3765 20.3097 26.2824C22.2634 28.1882 25.9057 27.6706 28.4625 25.1059C31.0193 22.5412 31.5258 18.9412 29.572 17.0353ZM20.6474 25.1059C20.6474 25.1059 23.373 23.7882 25.0373 20.8941C25.8574 19.4588 26.9911 18.8471 27.8353 18.4706C28.559 18.1412 29.0414 18.3294 29.1379 18.3529C29.0655 18.4 27.1841 19.2706 25.9298 21.4118C23.976 24.8235 20.768 25.1059 20.6474 25.1059Z",
    fill: "#BFE5B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_1471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeed);
export default __webpack_public_path__ + "static/media/seed.0a479e69153d007db7e08efbfb320019.svg";
export { ForwardRef as ReactComponent };